import appSlice from '../slices/appSlice';

export default {
  ...appSlice.actions,
};
